import { useRef, useCallback } from "react";

export function useDebounce(delay: number = 300) {
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const debounce = useCallback(async (callback: () => void) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current)
    }

    debounceTimerRef.current = setTimeout(callback, delay)
  }, [delay])

  return { debounce }
}

export function removeDuplicated(items: string[]) {
  return Array.from(new Set(items))
}